// oxlint-disable no-explicit-any

import { useSyncExternalStore, type FC } from "react"
type Uid = `${string}-${string}-${string}-${string}-${string}`

type Store = {
  Component: FC<any>
  props: any
  uid: Uid
  width?: string
}

let store: Store[] = []
// oxlint-disable-next-line no-empty-function
const noop = () => {}
let onStoreChange = noop

export const openModal = (val: Store): void => {
  store = [...store, val]
  onStoreChange()
}
export const closeModal = (uid: Uid): void => {
  store = store.filter((s) => s.uid !== uid)
  onStoreChange()
}

const getStore = () => store
const onChange = (handleChange: () => void) => {
  onStoreChange = handleChange
  return () => {
    onStoreChange = noop
  }
}

export const useModalStore = (): Store[] => {
  return useSyncExternalStore(
    onChange,
    getStore,
    // For a robust SSR scenario, you should provide getServerSnapshot:
    () => [],
  )
}
